import React from 'react';
import { Navigation } from '../components/Navigation';
import { TrialOfferCTA } from '../components/TrialOfferCTA';
import { Footer } from '../components/Footer';
import { BlogHero } from './blog/BlogHero';
import { BlogPost } from './blog/BlogPost';
import { BlogCTA } from './blog/BlogCTA';
export function BlogPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-319">
      <Navigation data-id="element-320" />
      <BlogHero data-id="element-321" />
      <BlogPost data-id="element-322" />
      <BlogCTA data-id="element-323" />
      <TrialOfferCTA data-id="element-324" />
      <Footer data-id="element-325" />
    </div>;
}